import { render } from "./DownloadCenter.vue?vue&type=template&id=0803e71d&ts=true"
import script from "./DownloadCenter.vue?vue&type=script&lang=ts"
export * from "./DownloadCenter.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__